import { connect } from 'react-redux';
import React, { Component } from 'react';
import {browserHistory} from 'react-router';

import {Snackbar} from 'material-ui';

class SnackBar extends Component {
  shouldComponentUpdate() {
    return true;
  }

  render() {
    const {open, message, action, handleClose} = this.props;
    return (
      <Snackbar
         open={open}
         message={message}
         action={action}
         autoHideDuration={4000}
         onRequestClose={handleClose}
      />
    );
  }
}

export default connect(
  state => (
    {
      open: state.get('snackbar').get('visible'),
      message: state.get('snackbar').get('message'),
      action: state.get('snackbar').get('action')
    }
  ),
  dispatch => (
    {
      handleClose(action) {
        dispatch({type: 'HIDE_SNACKBAR'});
      }
    }
  )
)(SnackBar);
